import { QuestionsInitialState } from '@common/feature/questions/types/general';

export const questionsInitialState: QuestionsInitialState = {
  showQuestions: false,
};
